import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Button,
  CircularProgress,
  Backdrop,
  Stack
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import LeakRemoveIcon from '@material-ui/icons/LeakRemove';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import CreateIcon from '@material-ui/icons/Create';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { baseUrl } from '../../utils/constants';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';
import CycleMgmtSub from './CycleMgmtSub';
import { useSettingContext } from '../../context/setting_context';
// import ClaimsLine from './ClaimsLine';
// import LineOverride from './LineOverride';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'strokes', label: 'Stroke #', alignRight: true },
  { id: 'monthlble', label: 'Month', alignRight: true },
  { id: 'provClaims', label: 'Run Monthly Bill', alignRight: true },
  { id: 'jnrsdone', label: 'Receipt SSB File', alignRight: true },
  { id: 'selfPpmts', label: 'Send Statements', alignRight: true },
  // { id: 'selfPmtsJnrs', label: 'Self Pmts Journals', alignRight: true },
  // { id: 'persAcc', label: 'Personal Acc', alignRight: true },
  { id: 'rate', label: 'Rate', alignRight: true },
  { id: 'curr', label: 'Active', alignRight: true },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function CycleMgmt() {
  const { setCycleId, setCycle, initializeCycle } = useSettingContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [cycleList, setCycleList] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopupOv, setOpenPopupOv] = useState(false);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [loading, setLoading] = useState(false);
  const [subItemId, setSubItemId] = useState(0);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    getCycleDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getCycleDetails = async (claimIds) => {
    await axios(`${baseUrl}/api/setting/getAllPayCycles`).then(
      (result) => {
        setCycleList(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const handleLineView = (e) => {
    console.log('e payclycle ', e);
    setCycleId(e.row.payCycleId);
    setCycle(e.row);
    setSubItemId(e.row.payCycleId);
    openView();
  };

  const handleOverride = (e) => {
    console.log('e claimLineId ', e);
    // refreshClaimLineById(e.claimDtl_id);
    openViewOv();
  };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const openView = (e) => {
    setOpenPopup(true);
  };

  const openNew = (e) => {
    setCycleId(0);
    initializeCycle();
    setOpenPopup(true);
  };

  const openViewOv = (e) => {
    setOpenPopupOv(true);
  };

  const closePopupOv = () => {
    setOpenPopupOv(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - cycleList.length) : 0;

  const filteredUsers = applySortFilter(cycleList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h6" gutterBottom>
          Process Cycles
        </Typography>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => openNew()}
        >
          Create New Cycle
        </Button>
      </Stack>
      <Card>
        <Scrollbar>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={cycleList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      payCycleId,
                      payDate,
                      processed,
                      selfPmts,
                      selfPmtsJournals,
                      chequesDone,
                      personalAccProc,
                      chequesPrinted,
                      rate,
                      active
                    } = row;
                    const isItemSelected = selected.indexOf(payCycleId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={payCycleId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{payCycleId}</TableCell>
                        <TableCell component="th" scope="row" padding="none" align="right">
                          {moment(payDate).isValid() ? moment(payDate).format('MMM-YYYY') : ''}
                        </TableCell>
                        <TableCell align="right">{processed ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="right">{chequesDone ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="right">{selfPmts ? 'Yes' : 'No'}</TableCell>
                        {/* <TableCell align="right">{selfPmtsJournals ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="right">{personalAccProc ? 'Yes' : 'No'}</TableCell> */}
                        <TableCell align="right">{rate.toLocaleString()}</TableCell>
                        <TableCell align="right">{active ? 'Yes' : 'No'}</TableCell>
                        <IconButton onClick={() => handleLineView({ row })}>
                          <VisibilityIcon sx={{ color: '#03a9f4' }} />
                        </IconButton>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.Popup
            title="Cycle Management"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <CycleMgmtSub closePopup={closePopup} id={subItemId} />
          </Controls.Popup>
          {/* <Controls.Popup
            title="Override Line"
            openPopup={openPopupOv}
            setOpenPopup={setOpenPopupOv}
          >
            <LineOverride closePopup={closePopupOv} claim_ID={claimNo} />
          </Controls.Popup> */}

          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={cycleList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
